<template>
  <div class="add_accident">
      <el-form :model="addForm" label-width="60px">
        <div class="table_top">
          <el-form-item prop="carId" label="车牌号">
            <el-select
              v-model="addForm.carId"
              filterable
              placeholder="请输入"
              clearable
            >
              <el-option
                v-for="item in carList"
                :key="item.carId"
                :label="item.plateNo"
                :value="item.carId"
              ></el-option>
            </el-select>
            <el-button type="primary" @click="addCol"  v-loading="tableLoading">添加</el-button>
          </el-form-item>

          <el-button class="mb16" type="primary" @click="batchUpload">批量添加车辆</el-button>
        </div>
      </el-form>
      <div class="mb16 summary">
        <span>应收金额为退车月份已生成应付单且已实收的情况才会生成</span>
      </div>
      <!-- eslint-disable vue/no-unused-refs -->
      <el-form :model="formTable" v-loading="tableLoading" ref="formTableRef">
      <!-- eslint-enable vue/no-unused-refs -->
        <el-table
          :data="formTable.list"
          style="width: 100%"
        >
          <el-table-column label="车辆ID">
            <template slot-scope="scope">
              <div>{{scope.row.carId}}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" >
            <template slot-scope="scope">
              <div>{{scope.row.brandName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="车系" >
            <template slot-scope="scope">
              <div>{{scope.row.seriesName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="车型" >
            <template slot-scope="scope">
              <div>{{scope.row.carModelName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="车牌号" width="120px">
            <template slot-scope="scope">
              <div>{{scope.row.plateNo}}</div>
            </template>
          </el-table-column>
          <el-table-column label="VIN码" width="180px">
            <template slot-scope="scope">
              <div>{{scope.row.vin}}</div>
            </template>
          </el-table-column>
          <el-table-column label="应付租金(元)" width="100px">
            <template slot-scope="scope">
              <div>{{scope.row.rentAmount}}</div>
            </template>
          </el-table-column>
          <el-table-column label="应退租金(元)" width="100px">
            <template slot-scope="scope">
              <div>{{scope.row.returnRentAmount}}</div>
            </template>
          </el-table-column>
          <el-table-column label="应付押金(元)" width="100px">
            <template slot-scope="scope">
              <div>{{scope.row.depositAmount}}</div>
            </template>
          </el-table-column>
          <el-table-column label="应退押金(元)" width="100px">
            <template slot-scope="scope">
              <div>{{scope.row.returnDepositAmount}}</div>
            </template>
          </el-table-column>
          <!-- 财务审批 需求中新增 字段 doc: https://bailongma.yuque.com/hhwu0d/yizg52/niomzpf77bxv6oog#sRRue -->
          <el-table-column label="付款中租金(元)" width="100px">
            <template slot-scope="scope">
              <div>{{scope.row.payingRentAmount}}</div>
            </template>
          </el-table-column>
          <el-table-column label="付款中押金(元)" width="100px">
            <template slot-scope="scope">
              <div>{{scope.row.payingDepositAmount}}</div>
            </template>
          </el-table-column>
          <!-- end -->
          <el-table-column label="退车时间"  width="170px" >
            <template slot-scope="scope">
              <el-form-item
                class="back_time"
                :prop="'list.' + scope.$index + '.returnCarDate'"
                :rules="[
                  {required:true,trigger:'change',message:'请选择'}
                ]"
              >
              <el-date-picker
                v-model="scope.row.returnCarDate"
                type="date"
                @change="(time)=>timeChange(time,scope.row.carId,scope.$index)"
                placeholder="请选择">
              </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right"  width="170px">
            <template slot-scope="scope">
              <el-button type="text" @click="exitCarSettle(scope.row,scope.$index)">退车核算</el-button>
              <el-button type="text" @click="delCol(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="total_area mt16">
          <span class="ml16">退车数量：<span>{{ formTable.list.length }}</span>辆</span>
          <span class="ml16">应付租金总额：<span v-thousand-separator="rentAmount"></span>元</span>
          <span class="ml16">应退租金总额：<span v-thousand-separator="returnRentAmount"></span>元</span>
        </div>
        <div class="total_area mt16">
          <span class="ml16">应付押金总额：<span v-thousand-separator="depositAmount"></span>元</span>
          <span class="ml16">应退押金总额：<span v-thousand-separator="returnDepositAmount"></span>元</span>
        </div>
      </el-form>
      <ImportPopup
        ref="importPopup"
        title="批量添加车辆"
        :templateUrl="batchExitCarTemplate"
        :upload="upload"
        group="order"
        code="order_vehicle_pic"
      >
        <div class="importInstructions">
          <div>
            <p>
              这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，请单击
              下载Excel标准模板。
            </p>
            <span>导入前准备</span>
            <ul>
              <li v-for="item of importInstructionsList" :key="item">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </ImportPopup>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="()=>{dialogVisible = false}">
        <p v-for="(item,index) in exportErrorMegs" :key="index">{{item}}</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
import ImportPopup from '@/components/ImportPopup'
import { returnableCarList, getCarDetail, carImportant, calculateCarAmount } from '@/api/purchaseAndSaleAPI/purchaseOrderApi'
import { batchExitCarTemplate } from '@/config'
import moment from 'moment'

export default {
  components: {
    ImportPopup,
  },
  props: {
    orderId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      batchExitCarTemplate,
      addForm: {
        carId: '',
      },
      carList: [],
      formTable: {
        list: [],
      },
      importInstructionsList: [
        '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板的原有内容，建议重新下载模板；',
        '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
        '3.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
        '4.确保excel中数据格式正确。比如VIN码为数字加字母格式，请不要输入汉字。',
        '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
        '6.Excel多余的列无法导入，请删除Excel中不需要导入的列；',
      ], // 导入说明列表
      rentAmount: 0, // 应付租金总额
      returnRentAmount: 0, // 应退租金总额
      depositAmount: 0, // 应付押金总额
      returnDepositAmount: 0, // 应退押金总额
      sessionCarId: '', // 缓存车辆id返回的时候回显
      tableLoading: false,
      exportErrorMegs: [],
    }
  },
  created() {
    const batchExitCarlistRouterFrom = sessionStorage.getItem('batchExitCarlistRouterFrom')
    this.getCarList()
    // 如果是刷新或者从采购订单页面跳转过来的删除缓存
    if (batchExitCarlistRouterFrom === 'null' || batchExitCarlistRouterFrom === 'purchase_order_manage') {
      this.operationSession().remove()
      return
    }
    this.operationSession().get()
    this.operationSession().remove()
  },
  watch: {
    tableLoading(v) {
      this.$emit('tableLoading', v)
    },
  },
  methods: {
    // 添加列
    addCol() {
      if (!this.addForm.carId) {
        this.$message.warning('请选择车牌号')
        return
      }
      // 列表中是否已存在需要添加的车辆
      const isHasItem = () => {
        return this.formTable.list.findIndex((item) => item.carId === this.addForm.carId)
      }
      if (isHasItem() > -1) {
        this.$message.warning('车辆已存在')
        this.addForm.carId = ''
        return
      }
      const ind = this.carList.findIndex((item) => item.carId === this.addForm.carId)
      // 获取到的车辆信息
      this.getCarItemInfo(this.carList[ind]).then((res) => {
        this.formTable.list.push(res)
        this.addForm.carId = ''
        this.calculTotal()
      })
    },
    // 退车时间切换
    timeChange(t, c, i) {
      if (!t) return
      this.tableLoading = true
      const col = this.formTable.list[i]
      calculateCarAmount({
        orderId: col.id,
        returnCarDate: `${moment(t).format('YYYY-MM-DD')} 00:00:00`,
        carId: c,
      }).then((res) => {
        this.tableLoading = false
        if (res.code !== 1) return
        const { rentAmount, returnRentAmount, returnDepositAmount } = res.data
        col.rentAmount = rentAmount || 0
        col.returnRentAmount = returnRentAmount || 0
        col.returnDepositAmount = returnDepositAmount || 0
        this.calculTotal()
      }).catch(() => {
        this.tableLoading = false
      })
    },
    // 计算总数
    calculTotal() {
      const { list } = this.formTable
      let rentAmount = 0; let returnRentAmount = 0; let depositAmount = 0; let returnDepositAmount = 0
      list.forEach((item) => {
        rentAmount += Number(item.rentAmount)
        returnRentAmount += Number(item.returnRentAmount)
        depositAmount += Number(item.depositAmount)
        returnDepositAmount += Number(item.returnDepositAmount)
      })
      this.rentAmount = rentAmount
      this.returnRentAmount = returnRentAmount
      this.depositAmount = depositAmount
      this.returnDepositAmount = returnDepositAmount
    },
    // 显示上传弹框
    batchUpload() {
      this.$refs.importPopup.showDialog()
    },
    // 上传文件事件
    upload(url) {
      return new Promise((resolve, reject) => {
        carImportant({
          fileAddress: url,
          orderId: this.orderId,
        }).then((res) => {
          if (res.code === 1) {
            const { orderCarInfos = [], exportErrorMegs = [] } = res.data
            if (exportErrorMegs && exportErrorMegs.length > 0) {
              this.exportErrorMegs = exportErrorMegs
              this.dialogVisible = true
              return
            }
            if (orderCarInfos && orderCarInfos.length > 0) {
              orderCarInfos.forEach((item) => {
                item.returnCarDate = item.returnDate
              })
              this.$set(this.formTable, 'list', orderCarInfos)
              this.calculTotal()
            }
          }
          this.$refs.importPopup.closeDialog()
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 删除列
    delCol(ind) {
      this.formTable.list.splice(ind, 1)
      // console.log(this.operationSession)
      this.operationSession().set()
      this.calculTotal()
    },
    // 缓存页面数据相关
    operationSession() {
      const setFn = (carId) => {
        const data = {
          carId,
          list: JSON.stringify(this.formTable.list),
        }
        sessionStorage.setItem('batchExitCarlistObj', JSON.stringify(data))
      }
      return {
        set: setFn,
        get: () => {
          const batchExitCarlistObj = JSON.parse(sessionStorage.getItem('batchExitCarlistObj'))
          if (!batchExitCarlistObj) return
          this.formTable.list = JSON.parse(batchExitCarlistObj.list) || []
          this.sessionCarId = batchExitCarlistObj.carId
          this.updateSessionCarIdData()
        },
        remove: () => {
          sessionStorage.removeItem('batchExitCarlistObj')
        },
      }
    },
    // 更新列表中缓存carId对应的列的数据
    updateSessionCarIdData() {
      if (!this.sessionCarId) return
      const ind = this.formTable.list.findIndex((item) => item.carId === this.sessionCarId)
      this.getCarItemInfo(this.formTable.list[ind]).then((res) => {
        this.formTable.list.splice(ind, 1, res)
        this.calculTotal()
      }).catch((err) => {
        console.log({ err })
      })
    },
    // 退车核算
    exitCarSettle(row) {
      this.operationSession().set(row.carId || '')
      this.$router.push({
        // path: '/purchase/purchase_manage/purchase_order_manage/sonOrderList/detail',
        path: '/purchaseOrder/sonOrderMange/detail',
        query: {
          type: 5, // 跳转到那个tab
          orderType: 'purchaseSonOrder', // 来自采购子订单列表
          id: row.id || row.orderId,
          from: 'batch',
          time: moment(row.returnCarDate).format('YYYY-MM-DD'),
        },
      })
    },
    // 获取订单对应的所有车辆列表
    getCarList() {
      returnableCarList({
        id: this.$route.query.id,
      }).then((res) => {
        this.carList = res.data || []
        this.carList.forEach((item) => {
          item.returnCarDate = Date.now()
        })
      })
    },
    // 获取车辆信息
    getCarItemInfo({ id, carId, plateNo, returnCarDate }) {
      return new Promise((resolve, reject) => {
        this.tableLoading = true
        getCarDetail({ carId, orderId: this.$route.query.id, plateNo }).then((res) => {
          this.tableLoading = false
          if (res.code === 1) {
            resolve({ ...res.data, returnCarDate: res.data.returnDate || returnCarDate, id })
          } else {
            reject(res.data)
          }
        }).catch((err) => {
          this.tableLoading = false
          reject(err)
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
.table_top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-top: -15px;
}
.summary{
  margin-left: 4px;
  font-size: 12px;
  color: #999;
}
.total_area{
  text-align: right;
}
.back_time{
  margin-bottom:0px;
  min-height: 48px;
  display: flex;
  align-items: center;
  ::v-deep .el-input__inner{
    width: 160px;
  }
}
</style>
